// @flow

import React from 'react';

import FormNode from '../Node';

import type { Node } from 'react';

import type { FormActions } from 'app/developer-v3/components/PartnerSupportForm/types';
import type { SelectedNode } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';
import type { States } from 'app/developer-v3/components/PartnerSupportForm/machine';

type Props = {
  actions: FormActions,
  nodes: SelectedNode[],
  state: States,
};

const Help = ({ actions, nodes, state }: Props): Node => {
  const helpNode = nodes[nodes.length - 1];

  return (
    <FormNode
      actions={actions}
      key={helpNode.pathId}
      node={helpNode}
      state={state}
    />
  );
};

export default Help;
